import { QueryClient } from '@tanstack/react-query';

/**
 * Single QueryClient for the whole app. Defaults are tuned for mobile:
 *   - 30s staleTime so common screens skip refetch on focus
 *   - 5min gcTime so background-cached data survives quick screen swaps
 *   - retry once on transient failures, no retry on 4xx
 *   - refetch on window focus disabled (annoying on web, irrelevant on native)
 *
 * Kept in a leaf module (no app/store imports) so stores can import it for
 * cache invalidation without an import cycle through `@app/providers`.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        const status = (error as { status?: number } | null)?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
